import {defineStore} from "pinia";
import type {Kpi, KpiMetadata, TimeInterval} from "~/types/kpi";
import type {Diagnostic} from "~/types/diagnostic";
import {useI18n} from "vue-i18n";

export const useKpiStore = defineStore('kpiStore', () => {
    const {t} = useI18n()
    const kpiMetadata = ref<KpiMetadata>({results: [], performances: []})
    const kpis = ref<Kpi[]>([])
    const diagnostic = ref<Diagnostic | undefined>()
    const runtimeConfig = useRuntimeConfig()
    const decathStore = useDecathlonStores()
    const timeIntervalSelected = ref<TimeInterval>('YEAR_TO_DATE')

    const kpisOnAlert = ref<string[]>([])

    const getThemes = () => diagnostic.value?.themes

    const fetchKpiMetadata = async () => {
        if (!decathStore.selectedCrossDiag) return kpiMetadata.value
        kpiMetadata.value = {results: [], performances: []}
        kpiMetadata.value = await useFetchWithToken<KpiMetadata>('fetchKpiMetadata', `${runtimeConfig.public.apiBase}/v1/kpis/metadata?diagnosticId=${decathStore.selectedCrossDiag?.id}`, {
            method: 'get',
        }) ?? {results: [], performances: []}
        return kpiMetadata.value
    }
    const fetchKpi = async (kpi: Kpi, timeInterval: TimeInterval, isLoading: Ref<boolean>) => {
        const data = await useFetchWithToken<Kpi>('fetchKpi', `${runtimeConfig.public.apiBase}/v1/kpis/store/${kpi.code}?timeInterval=${timeInterval}&storeId=${decathStore.selectedStore!.id}`, {
            method: 'get',
        }, isLoading)

        if (data) {
            kpis.value = useUniqBy([...kpis.value, data], 'code')
        } else throw createError({
            message: t('error.kpi-failed',{kpiLabel : kpi.label}),
            fatal: false,
            status: 404
        })
        return data
    }

    const createDiagnosticByKpis = async () => {
        if (!decathStore.selectedCrossDiag) return diagnostic.value
        const runtimeConfig = useRuntimeConfig()
        diagnostic.value = await useFetchWithToken<Diagnostic>('fetchKpi', `${runtimeConfig.public.apiBase}/v1/diagnostic/store/kpis?storeId=${decathStore.selectedStore!.id}&diagnosticId=${decathStore.selectedCrossDiag?.id}`, {
            method: 'post',
            body: kpisOnAlert.value
        })
        return diagnostic.value
    }

    return {
        kpiMetadata,
        kpisOnAlert,
        kpis,
        diagnostic,
        fetchKpiMetadata,
        fetchKpi,
        createDiagnosticByKpis,
        getThemes,
        timeIntervalSelected
    }
})
